<template>
	<div>
		<div class="container" style="position: relative;">
			<div class="xian"></div>
			<div class="yuan1">2008</div>
			<div class="yuan2">2009</div>
			<div class="yuan3">2013</div>
			<div class="row">
				<div class="col-sm-9 offset-2">
					<div class="container_li">

						<div class="cont">
							<div class="tit">破茧而出</div>
							<div class="list">
								<span>3月，金利高品牌正式成立；</span>
								<span>4月，金利高陶瓷成功体验馆荣耀开馆；</span>
								<span>10月，通过中国国家强制性产品认证；</span>
								<span>12月，通过环境管理体系认证、质量管理体系认证。</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-9 offset-2">
					<div class="container_li">

						<div class="cont">
							<div class="tit">蜕变腾飞</div>
							<div class="list">
								<span>1月，投入巨资在央视投入广告，实现蜕变腾飞。 </span>
								<span>9月，通过中国环境标志认证。</span>
								<span>9-10月，《动感营销》销售精英培训营在佛山、杭州、郑州、沈阳成功举办。 </span>
								<span>11月，正式由中国太平洋财产保险股份有限公司承保产品质量。</span>
							
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-9 offset-2">
					<div class="container_li">

						<div class="cont">
							<div class="tit">高速发展</div>
							<div class="list">
								<span>	5月，金利高全抛釉瓷片盛大上市，掀起了金利高瓷片产品发展新的一页。 </span>
								<span>5月，通过“建材环保产品认证”</span>
								<span>6月，金利高全抛釉仿古砖“尊品·韵彩”隆重推出，填补了金利高陶瓷在仿古砖市场上的空白。 </span>
								<span>12月，金利高陶瓷应用“圆方软件”终端预售设计系统,品牌信息化建设迈向一个新台阶。</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {}
	}
</script>

<style scoped lang="less">
	@w: 19.2vw;
	.yuan1,
	.yuan2,
	.yuan3 {
		background: #166BAB;
		border-radius: 50%;
		width: 100/@w;
		height: 100/@w;
		text-align: center;
		color: #FFFFFF;
		font-size: 16/@w;
		font-weight: bold;
		position: absolute;
		left: 10%;
		top: 0;
		margin-left: -50/@w;
		line-height: 100/@w ;
	}
	
	@media screen and (max-width: 768px) {
		.yuan1,
		.yuan2,
		.yuan3 {
			width: 40px;
			height: 40px;
			line-height: 40px;
			margin-left: -20px;
		}
	}
	
	.yuan1 {
		top: 9%;
	}
	
	.yuan2 {
		top: 42%;
	}
	
	.yuan3 {
		top: 75%;
	}
	
	.tit {
		color: #166BAB;
		font-size: 18/@w;
		font-weight: bold;
	}
	
	.list {
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 17px -4px rgba(0, 0, 0, 0.5);
		border-radius: 10px;
		padding: 20/@w;
		margin-bottom: 40/@w;
		span {
			display: block;
			color: #8A8A8A;
			font-size: 18/@w;
			font-weight: bold;
		}
	}
	
	.xian {
		position: absolute;
		left: 10%;
		top: 0;
		width: 0;
		height: 100%;
		border-right: 8/@w dashed #D1B8A2;
	}
</style>


// WEBPACK FOOTER //
// src/components/devellopmebt/index.vue